import React from "react";
import { Box, Divider, styled } from "@mui/material";
import { HatInfo } from "./HatInfo";
import { ClusterChip } from "./ClusterChip";
import { RelatedHats } from "./RelatedHats";
import { PathwaySection } from "./PathwaySection";
import type { MSHatData, RelatedHat } from "../../types";

interface LeftPanelProps {
  hat: MSHatData;
  onHatClick?: (hatId: string) => void;
  onPathwayClick?: (pathwayId: string) => void;
  demandRegionName?: string;
  demandLabel?: string;
}

const PanelContainer = styled(Box, {
  label: "LeftPanelContainer",
})(() => ({
  width: 368,
  flexShrink: 0,
  height: 569,
  display: "flex",
  flexDirection: "column",
  gap: 16,
  overflow: "visible",
}));

const BottomRow = styled(Box, {
  label: "LeftPanelBottomRow",
})(() => ({
  display: "flex",
  gap: 16,
  flex: 1,
  minHeight: 0,
}));

const BottomSection = styled(Box, {
  label: "LeftPanelBottomSection",
})(() => ({
  width: 176,
  flexShrink: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 16,
}));

export const LeftPanel = ({
  hat,
  onHatClick,
  onPathwayClick,
  demandRegionName,
  demandLabel,
}: LeftPanelProps) => {
  const relatedHats: RelatedHat[] = (hat.alsoLike || [])
    .filter((item) => item.relatedHat)
    .map((item) => item.relatedHat);

  return (
    <PanelContainer>
      <HatInfo
        displayName={hat.displayName}
        description={hat.msTextOverview || hat.msShortDescription}
        demandPercentChange={hat.growth?.percentChange}
        demandLabel={demandLabel}
        demandRegionName={demandRegionName}
      />

      {hat.msCareerCluster && hat.msCareerCluster.length > 0 && (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: -1 }}>
          {hat.msCareerCluster.map((cluster) => (
            <ClusterChip
              key={cluster.id}
              cluster={cluster}
              truncate={hat.msCareerCluster!.length > 1}
            />
          ))}
        </Box>
      )}

      <Divider sx={{ borderColor: "rgba(145, 158, 171, 0.2)" }} />

      <BottomRow>
        <BottomSection>
          <RelatedHats hats={relatedHats} onHatClick={onHatClick} />
        </BottomSection>
        <BottomSection>
          <PathwaySection
            pathways={hat.msPathway}
            whatCanIDo={hat.msWhatCanIDo}
            onPathwayClick={onPathwayClick}
          />
        </BottomSection>
      </BottomRow>
    </PanelContainer>
  );
};
